var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      ref: "vspopup-teacher",
      attrs: {
        title: _vm.$t("teacher.titles"),
        active: _vm.visible,
        id: "popup-teacher",
      },
      on: {
        "update:active": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closePopup,
      },
    },
    [
      _vm.visible
        ? _c("Grid", {
            ref: "grid-teacher-popup",
            attrs: {
              multipleSelect: true,
              service: _vm.teacherService,
              route_name: "teachers",
              hide_actions: "true",
              order_column: "teacher_name",
              "request-params": _vm.filtersGrid,
              columnDataKeys: {
                "ppl.people_view.name": "teacher_name",
                "ppl.people_view.email": "teacher_email",
              },
            },
            on: { changedSelection: _vm.changedSelection },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex flex-row justify-end gap-4" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "primary", icon: "add" },
              on: { click: _vm.addTeachers },
            },
            [_vm._v(" " + _vm._s(_vm.$t("adicionar")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }